import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();


  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      
      if (el) el.scrollIntoView({ behavior: "smooth" }) ;
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      return;
    }
    
    window.scrollTo(0, 0); 
    // setTimeout(() => {
    //   navigate(location.pathname, { replace: true });
    // }, 300);

  }, [location]);

  return null;
}
